module.exports = __webpack_public_path__ + "img/has-red-image.a7985794.png";